import { motion } from 'framer-motion';
import React from 'react';

interface ServiceCardProps {
	title: string;
	description: string;
	icon?: React.ReactNode;
}

export default function ServiceCard({ title, description, icon }: ServiceCardProps) {
	const ref = React.useRef<HTMLDivElement>(null);

	function handleMouse(e: React.MouseEvent<HTMLDivElement>) {
		const el = ref.current;
		if (!el) return;
		const rect = el.getBoundingClientRect();
		const x = e.clientX - rect.left;
		const y = e.clientY - rect.top;
		el.style.setProperty('--x', `${x}px`);
		el.style.setProperty('--y', `${y}px`);
	}

	return (
		<motion.div
			ref={ref}
			onMouseMove={handleMouse}
			initial={{ opacity: 0, y: 12 }}
			animate={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.4 }}
			className="group relative overflow-hidden rounded-xl border border-gray-200 shadow-sm transition hover:-translate-y-1 hover:shadow-xl h-full flex flex-col"
		>
			{/* Mouse tracking effect */}
			<div className="absolute inset-0 pointer-events-none opacity-0 group-hover:opacity-100 transition" style={{ background: 'radial-gradient(600px circle at var(--x,50%) var(--y,50%), rgba(6,182,212,0.15), transparent 40%)' }} />
			
			{/* Animated gradient border - testing with solid color first */}
			<div className="absolute inset-0 rounded-xl pointer-events-none opacity-100 transition-all duration-300 z-10">
				<div 
					className="absolute inset-0 rounded-xl p-[3px]"
					style={{ 
						background: 'red',
						border: '2px solid blue'
					}} 
				>
					<div className="w-full h-full rounded-xl bg-white"></div>
				</div>
			</div>
			
			{/* Content */}
			<div className="relative rounded-xl bg-white h-full flex flex-col p-5 z-20">
				<div className="rounded-xl bg-white p-0 h-full flex flex-col">
					<div className="mb-3 h-10 w-10 rounded-lg bg-primary/10 text-primary grid place-items-center">
						{icon}
					</div>
					<h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">{title}</h3>
					<p className="mt-2 text-sm text-gray-600 flex-1">{description}</p>
				</div>
			</div>
		</motion.div>
	);
}
